'use client';

import { useTranslations } from '@northladder/i18n';
import { TBidTag } from '@northladder/services';

interface IBidRankTranslations {
  description: string;
  label: string;
  title: string;
}

/**
 * This receives the `rank` and returns a well translated label.
 * If the rank is not recognized, it defaults to `"No Bids"`.
 */
export function useBidRankTranslations(
  rank: TBidTag
): IBidRankTranslations {
  const t = useTranslations('DesignSystemComponents.Bidding');

  switch (rank) {
    case 'winning':
      return {
        label: t('winning.label'),
        title: t('winning.title'),
        description: t('winning.description'),
      };
    case 'rank-one':
      return {
        label: t('rankOne.label'),
        title: t('rankOne.title'),
        description: t('rankOne.description'),
      };
    case 'runner-up':
      return {
        label: t('runnerUp.label'),
        title: t('runnerUp.title'),
        description: t('runnerUp.description'),
      };
    case 'in-queue':
      return {
        label: t('inQueue.label'),
        title: t('inQueue.title'),
        description: t('inQueue.description'),
      };
    case 'not-winning':
      return {
        label: t('notWinning.label'),
        title: t('notWinning.title'),
        description: t('notWinning.description'),
      };
    case 'out-of-qty':
      return {
        label: t('outOfQty.label'),
        title: t('outOfQty.title'),
        description: t('outOfQty.description'),
      };
    case 'my-bids':
      return {
        label: t('myBids.label'),
        title: t('myBids.title'),
        description: t('myBids.description'),
      };
    case 'no-bids':
    default:
      return {
        label: t('noBids.label'),
        title: t('noBids.title'),
        description: t('noBids.description'),
      };
  }
}
